<template>
  <div class="home">
    <DocumentGrid msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import DocumentGrid from '@/components/DocumentGrid.vue'

export default {
  name: 'Grid',
  components: {
    DocumentGrid
  }
}
</script>
